import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
// @ts-expect-error
import { wixStyleReactProviderDriverFactory } from '../WixStyleReactProvider/WixStyleReactProvider.uni.driver';

export const wixDesignSystemProviderDriverFactory = (
  base: UniDriver,
  body: UniDriver,
) => {
  return {
    ...wixStyleReactProviderDriverFactory(base, body),
  };
};

export type WixDesignSystemProviderUniDriver = ReturnType<
  typeof wixDesignSystemProviderDriverFactory
>;
